// Action types
export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR = 'SET_ERROR';
export const SET_SUCCESS = 'SET_SUCCESS';
export const CLEAR_STATUS = 'CLEAR_STATUS';

// Initial state
export const initialState = {
    loading: {
        data: false,
        processingStatus: false,
        notes: false
    },
    error: {
        message: "",
        display: false,
        detailsSearch: "",
        displayDetailsSearch: false
    },
    success: {
        message: "",
        display: false,
        statusUpdate: false
    }
};

// Reducer
export function statusReducer(state, action) {
    switch (action.type) {
        case SET_LOADING:
            return {
                ...state,
                loading: {
                    ...state.loading,
                    [action.payload.key]: action.payload.value
                }
            };
        case SET_ERROR:
            return {
                ...state,
                error: {
                    ...state.error,
                    ...action.payload
                }
            };
        case SET_SUCCESS:
            return {
                ...state,
                success: {
                    ...state.success,
                    ...action.payload
                }
            };
        case CLEAR_STATUS:
            return {
                ...state,
                [action.payload]: initialState[action.payload]
            };
        default:
            return state;
    }
} 